import Vue from 'vue';
import notifyOnReadableError from '@/utils/error-handler';

function install(Vue) {
  Vue.config.errorHandler = (error, vm, info) => {
    console.error(error, info);
    return notifyOnReadableError(error);
  };

  function logError(error) {
    Vue.config.errorHandler(error, null, 'manual call');
  }

  Vue.$logError = logError;
  Vue.prototype.$logError = logError;
}

Vue.use(install);
